// Панель с группой полей ввода

import type { ReactNode } from 'react';
import './InputPanel.css';

interface InputPanelProps {
  title?: string;
  children: ReactNode;
  className?: string;
}

export function InputPanel({ title, children, className = '' }: InputPanelProps) {
  return (
    <div className={`input-panel ${className}`}>
      {title && <h3 className="input-panel__title">{title}</h3>}
      <div className="input-panel__content">
        {children}
      </div>
    </div>
  );
}
